import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  redemption: state.redemption.activeRedemption,
  pageUrl: state.table.detailUrl,
});

angular
  .module('myConsultApp')
  .controller(
    'redemptionDetailController',
    ($compile, $ngRedux, $scope, $rootScope, $location, $timeout, $http, ENV) => {
      $scope.container_class = 'redemption-detail-container';
      $scope.isRedemptionActionMenu = false;
      $scope.updatedStatusId = 0;
      $scope.modalError = null;
      $scope.modalProcessing = false;

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.createModal = async (content) => {
        angular.element(document.querySelector('.admin-overlay-modal')).remove();
        angular.element(document.querySelector('.admin-modal')).remove();
        let $body = $(content);
        let temp = $compile($body)($scope);
        await angular.element(document.body).append(temp);
        setTimeout(() => {
          angular.element(document.querySelector('.admin-modal')).addClass('display');
        }, 150);
      };

      $scope.close = () => {
        $scope.updatedStatusId = null;
        $rootScope.closeComponent();
      };

      $scope.showRedemptionActionMenu = () => {
        $scope.isRedemptionActionMenu = !$scope.isRedemptionActionMenu;
      };

      $scope.updateRedemptionStatus = () => {
        $scope.createModal(
          '<div class="admin-modal"><h2>Update Redemption Status</h2><p>Please select an updated status:</p>' +
            '<select name="updatedStatusId" ng-model="updatedStatusId">' +
            '<option value="0" disabled selected>Choose an option</option>' +
            '<option ng-if="redemption.status.id != 1 && redemption.reward.fulfillment_partner == \'onbe\' && [1, 2, 3].indexOf(redemption.status.id) !== -1" value="1">Processing Complete</option>' +
            '<option ng-if="redemption.status.id != 2 && redemption.reward.fulfillment_partner == \'onbe\' && [1, 2, 3].indexOf(redemption.status.id) !== -1 && redemption.wirecard_information.wirecard_verified == false && redemption.wirecard_information.wirecard_ecount_id == null && [\'PROCESSED_SUCCESSFULLY\', \'PROCESSING\', \'PROCESSING_FAILED\'].indexOf(redemption.wirecard_information.wirecard_status) === -1" value="2">Errored with Wirecard</option>' +
            '<option ng-if="redemption.status.id != 3 && redemption.reward.fulfillment_partner == \'onbe\' && [1, 2, 3].indexOf(redemption.status.id) !== -1 && redemption.wirecard_information.wirecard_verified == false && redemption.wirecard_information.wirecard_ecount_id == null && [\'PROCESSED_SUCCESSFULLY\', \'PROCESSING\', \'PROCESSING_FAILED\'].indexOf(redemption.wirecard_information.wirecard_status) === -1" value="3">Errored with Atlas</option>' +
            '</select>' +
            "<p>Please confirm that you understand that changing this status without verifying the status in third-party systems could cause data discrepancies and negatively affect the user's point balance.</p><br /><br />" +
            '<p style="font-weight: bold;">You should be sure that you are changing the status correctly.</p>' +
            '<p class="error" ng-if="modalError">{{ modalError }}</p>' +
            '<img ng-show="modalProcessing" class="loading-gif" src="./images/loading.gif" alt="Loading..." />' +
            '<button ng-show="!modalProcessing" type="submit" ng-disabled="!updatedStatusId" ng-click="updateRedemptionStatusConfirm()">Submit</button>' +
            '<a class="cancel-button" ng-click="updatedStatusId = 0;modalError = null;hideModal();updatedStatusId == null;">Cancel</a></div><div class="admin-overlay-modal"></div>',
        );
      };

      $scope.updateRedemptionStatusConfirm = () => {
        if ($scope.updatedStatusId) {
          $scope.modalProcessing = true;
          let redemptionData = {
            redemptions: {
              status_id: $scope.updatedStatusId,
            },
          };
          $scope
            .updateRedemption($http, ENV, $scope.redemption.id, redemptionData)
            .then(() => {
              $scope.modalError = null;
              $scope.modalProcessing = false;
              $scope.updatedStatusId = 0;
              $scope.getLoyaltyStatistics($http, ENV, $rootScope.userId);
              $scope.hideModal();
              $rootScope.getDataByUrl($scope.pageUrl);
            })
            .catch((error) => {
              $scope.modalError = error.data.redemptions;
              $scope.modalProcessing = false;
            });
        }
      };

      $scope.retryRedemption = () => {
        $scope.createModal(
          '<div class="admin-modal"><h2>Retry Redemption</h2>' +
            '<p>This process will first retry the redemption request to Wirecard. Please manually confirm that this redemption has not been processed in Wirecard.</p><br /><br />' +
            "<p style='font-weight: bold;'>Please confirm that you understand that retrying this redemption without verifying the current status in Atlas as well as the status in third-party systems could cause data discrepancies and negatively affect the user's point balance. You should be sure that you are changing the status correctly.</p>" +
            '<p class="error" ng-if="modalError">{{ modalError }}</p>' +
            '<img ng-show="modalProcessing" class="loading-gif" src="./images/loading.gif" alt="Loading..." />' +
            '<button ng-show="!modalProcessing" type="submit" ng-click="retryRedemptionConfirm();">Submit</button>' +
            '<a class="cancel-button" ng-click="modalError = null;hideModal();">Cancel</a></div><div class="admin-overlay-modal"></div>',
        );
      };

      $scope.retryRedemptionConfirm = () => {
        $scope.modalProcessing = true;
        let redemptionData = {
          redemptions: {
            retry_redemption: 1,
          },
        };
        $scope
          .updateRedemption($http, ENV, $scope.redemption.id, redemptionData)
          .then(() => {
            $scope.modalError = null;
            $scope.modalProcessing = false;
            $scope.updatedStatusId = 0;
            $scope.getLoyaltyStatistics($http, ENV, $rootScope.userId);
            $scope.hideModal();
            $rootScope.getDataByUrl($scope.pageUrl);
          })
          .catch((error) => {
            $timeout(() => {
              $scope.modalProcessing = false;
              $scope.modalError = error.data.redemptions[0];
            });
          });
      };

      $scope.deleteRedemptionRecord = () => {
        $scope.createModal(
          '<div class="admin-modal"><h2>Delete Redemption</h2><p>Are you sure you want to delete this redemption? You cannot undo this action.</p><br /><br />' +
            '<p style="font-weight: bold;">Please verify in third-party systems that the redemption does not exist.</p>' +
            '<p class="error" ng-if="modalError">{{ modalError }}</p>' +
            '<img ng-show="modalProcessing" class="loading-gif" src="./images/loading.gif" alt="Loading..." />' +
            '<button ng-show="!modalProcessing" type="submit" ng-click="deleteRedemptionConfirm();">Delete</button>' +
            '<a class="cancel-button" ng-click="modalError = null;hideModal();">Cancel</a></div><div class="admin-overlay-modal"></div>',
        );
      };

      $scope.deleteRedemptionConfirm = () => {
        $scope.modalProcessing = true;
        $scope
          .deleteRedemption($http, ENV, $scope.redemption.id)
          .then(() => {
            $scope.modalError = null;
            $scope.modalProcessing = false;
            $scope.updatedStatusId = 0;
            $scope.getLoyaltyStatistics($http, ENV, $rootScope.userId);
            $scope.hideModal();
            $scope.close();
            $rootScope.getDataByUrl($scope.pageUrl);
          })
          .catch((error) => {
            $timeout(() => {
              $scope.modalProcessing = false;
              $scope.modalError = error.data.redemptions;
            });
          });
      };
      

      $scope.getTypeOfString = (value) => {
        if (typeof(value) === 'string' || typeof(value) == "boolean" || typeof(value) == "number") {
          return true;
        } else {
          return false;
        }
      }

      $(document).on('click', (event) => {
        const settingEle = $('.header-actions');

        if (settingEle !== event.target && !settingEle.has(event.target).length) {
          $scope.$apply(() => {
            $scope.isRedemptionActionMenu = false;
          });
        }
      });

      $scope.init();
      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
      });
    },
  )
  .directive('redemptionDetail', () => {
    return {
      templateUrl: 'templates/v2/redemption-detail.html',
    };
  });
